import * as Apollo from '@apollo/client'
import {
  GQL_LatestBatteryReadingPerBoxQuery,
  GQL_LatestBatteryReadingPerBoxQueryVariables,
  useLatestBatteryReadingPerBoxQuery,
} from '../../../generated/graphql'
import {transformBatteryReading} from '../../../gql/transformBatteryReading'

export const useLatestBatteryReadingPerBox = (
  baseOptions?: Apollo.QueryHookOptions<GQL_LatestBatteryReadingPerBoxQuery, GQL_LatestBatteryReadingPerBoxQueryVariables>,
) => {
  const {data, ...rest} = useLatestBatteryReadingPerBoxQuery(baseOptions)
  return {
    ...rest,
    data: data?.battery?.latestBatteryReadingPerBox.map(transformBatteryReading) ?? [],
  }
}
